import { Tooltip } from '@material-ui/core';
import React from 'react'

export default function RenderTooltipTitles(props) {
    return (
        <div className="d-flex">
            <Tooltip title={props?.label}>
                <span className="form-addTicket-label text-truncate">
                    <label className="text-truncate line-height-18">{props?.label}
                    </label>
                </span>
            </Tooltip>
            {props.data.structure.required && <span className="required padding-left-4">*</span>}
        </div>
    );
}
